import { PresetMedia } from '@nucleus/types/web';

export const leaderCardMediaFull: PresetMedia = {
  mediaOptions: {
    blending: {
      blendMode: 'none',
      fade: 'bottom',
      fadeIntensity: 0.35,
    },
    image: {
      tile: 'none',
      scale: 'cover',
    },
    video: {
      image: {
        tile: 'none',
        scale: 'cover',
      },
    },
    useColor: false,
  },
};
